import { render, staticRenderFns } from "./editsysdicItem.vue?vue&type=template&id=dc3f8068"
import script from "./editsysdicItem.vue?vue&type=script&lang=js"
export * from "./editsysdicItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports